import React from 'react';
import {Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, IconButton} from '@mui/material';
import { RenderParticipantName } from './Elements';
import StyledLink from '../utils/StyledLink';
import Trend from '../utils/Trend';
import InfoIcon from "@mui/icons-material/Info"; // Import the Trend component

interface Props {
    data: any[];
    onParticipantClick: (participantId: number, name: string) => void;
}

const FrequencyTable: React.FC<Props> = ({ data, onParticipantClick }) => (
    <TableContainer component={Paper}>
        <Table>
            <TableHead>
                <TableRow>
                    <TableCell />
                    <TableCell>Участник</TableCell>
                    <TableCell>Записей</TableCell>
                    <TableCell>Разных заруб</TableCell>
                    <TableCell>Наиболее частая заруба</TableCell>
                    <TableCell>Последняя активность</TableCell>
                </TableRow>
            </TableHead>
            <TableBody>
                {data.map((row) => (
                    <TableRow
                        key={row.participant_id}
                        sx={{
                            cursor: 'pointer',
                            '&:hover': { backgroundColor: 'rgba(0, 0, 0, 0.04)' }, // Highlight on hover for desktop
                        }}
                        onClick={() => onParticipantClick(row.participant_id, row.participant_name)} // Entire row clickable
                    >
                        {/* Icon for drill-down */}
                        <TableCell padding="checkbox" onClick={(e) => e.stopPropagation() /* Prevent row click */}>
                            <IconButton
                                onClick={() => onParticipantClick(row.participant_id, row.participant_name)}
                                size="small"
                                aria-label="Подробнее"
                            >
                                <InfoIcon color="primary" />
                            </IconButton>
                        </TableCell>
                        <TableCell>
                            {RenderParticipantName(row.participant_id, row.participant_name, row.profile_picture, true)}
                        </TableCell>

                        {/* Total Entries with Trend Icon */}
                        <TableCell>
                            <Trend trend={row.activity_trend} showSteady={false} /> {row.total_entries}
                        </TableCell>

                        {/* Total Contests with Trend Icon */}
                        <TableCell>
                            <Trend trend={row.versatility_trend} showSteady={false} /> {row.total_contests}
                        </TableCell>

                        {/* Most Frequent Contest */}
                        <TableCell>
                            <StyledLink to={`/contest/${row.most_frequent_contest_id}`}>{row.most_frequent_contest}</StyledLink>
                        </TableCell>

                        {/* Last Activity */}
                        <TableCell>{new Date(row.updated_at).toLocaleString()}</TableCell>
                    </TableRow>
                ))}
            </TableBody>
        </Table>
    </TableContainer>
);

export default FrequencyTable;
